//import React from 'react';
const PAGE = [
  {
    "content": `Nombre`
  },
  {
    "content": `Identificación del tratamiento`
  },
  {
    "content": `Creado`
  },
  {
    "content": `Paso`
  },
  {
    "content": "Ver"
  },
  {
    "content": "Acción"
  },
  {
    "content": "No se encontraron artículos"
  },
  {
    "content": "Editar"
  },
  {
    "content": "Creando"
  },
  {
    "content": "Aprobar"
  }
];


export default PAGE;